import { SET_SHOW_LAUNCHDECK_BRANDING } from "../../actions/dsr-actions-types";


const INITIAL_STATE_SHOW_LAUNCHDECK_BRANDING = { results: "" }

export function setShowLaunchdeckBrandingReducer(state = INITIAL_STATE_SHOW_LAUNCHDECK_BRANDING, action) {
    switch (action.type) {
        case SET_SHOW_LAUNCHDECK_BRANDING:
            return { results: action.payload }
        default:
            return state;
    }
}